<template>
  <div class="verification pt-4 mt-4">
    <b-col class="col-12 align-content-center py-2 py-md-3 py-xl-4">
      <div class="mx-auto col-10 col-md-4 col-xl-3 py-2">
        <b-img
          :src="require(`@/assets/${$root.scope}/logo.svg`)"
          fluid-grow
          :alt="$t('EmailVerification.logo_alt')"
        ></b-img>
      </div>
    </b-col>

    <div v-if="$route.params.status === 'success'">
      <h5>{{ $t('registrazione_successo') }}</h5>
      <div class="col-10 mx-auto">
        <h1 class="mt-3 text-center pb-1">{{ $t('benvenuto') }}</h1>
        <h6 class="text-center my-4 py-3 pl-1">
          {{ $t('email_confermata_successo') }}
        </h6>
        <b-button
          v-if="hasAccessToken"
          type="button"
          variant="secondary text-white mx-2 mt-4"
          @click="logAndHome"
        >
          {{ $t('vai_homepage') }}
        </b-button>
        <b-button
          v-else
          type="button"
          variant="secondary text-white mx-2 mt-4"
          @click="$router.push({ name: 'LoginPage' })"
        >
          {{ $t('vai_al_login') }}
        </b-button>
      </div>
    </div>

    <div v-else-if="$route.params.status === 'already'">
      <h5>{{ $t('email_gia_verificata') }}</h5>
      <div class="col-10 mx-auto">
        <h1 class="mt-3 text-center pb-1">{{ $t('benvenuto') }}</h1>
        <h6 class="text-center my-4 py-3 pl-1">
          {{ $t('email_gia_verificata_descrizione') }}
        </h6>
        <b-button
          v-if="isAuthenticated"
          type="button"
          variant="secondary text-white mx-2 mt-4"
          @click="$router.push({ name: 'Home', query: { redirect: 'profilo' } })"
        >
          {{ $t('vai_scheda_anagrafica') }}
        </b-button>
        <b-button
          v-else
          type="button"
          variant="secondary text-white mx-2 mt-4"
          @click="$router.push({ name: 'LoginPage' })"
        >
          {{ $t('vai_al_login') }}
        </b-button>
      </div>
    </div>

    <div v-else>
      <h5></h5>
      <div class="col-10 mx-auto">
        <h1 class="mt-3 text-center pb-1">{{ $t('conferma_email') }}</h1>
        <h6 class="text-center my-4 py-3 pl-1">
          <span class="text-danger" v-if="$route.query.mailtoken">
            {{ $t('link_non_valido') }}
          </span>
          {{ $t('email_non_ricevuta_controlla_spam') }}
          <span
            class="point"
            role="button"
            tabindex="0"
            @click="submitResend"
            @keydown.enter.prevent="submitResend"
            @keydown.space.prevent="submitResend"
          >
            {{ $t('richiedi_nuova_mail') }}
          </span>
        </h6>
        <b-button
          @click="submitResend"
          type="button"
          variant="secondary text-white mx-2 mt-4"
        >
          {{ $t('invia_nuova_mail') }}
        </b-button>
      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

import { mapState, mapActions } from "vuex";
export default {
  name: "EmailVerification",
  components: {
    // HelloWorld,
  },
  computed: {
    ...mapState("utente", ["status", "user"]),
    hasAccessToken() {
      return !!this.$route.query.access_token;
    },
    isAuthenticated() {
      return this.user && this.user.email_verified_at;
    },
  },
  methods: {
    ...mapActions("utente", ["resend", "me"]),
    submitResend() {
      this.resend().then(function (hh) {
        console.log("thend");
      });
    },
    async logAndHome() {
      if (this.$route.query.access_token) {
        try {
          await this.me(this.$route.query.access_token);
          this.$router.push({ name: "Home" });
        } catch (error) {
          console.log("Errore autenticazione", error);
          this.$router.push({ name: "LoginPage" });
        }
      } else {
        this.$router.push({ name: "Home" });
      }
    },
  },
  mounted() {},
};
</script>
